//export const ajaxUrl = "http://vattenfall.iza/ajaxhandler.php";
export const ajaxUrl = "https://staging.ves.vlink-next-energy.de/ajaxhandler.php";
//export const ajaxUrl = "https://ves.vlink-next-energy.de/ajaxhandler.php";
